import { Injectable, Signal } from '@angular/core';

import { Stage } from '@core/stages-types';

@Injectable()
export abstract class ChangeStageActionDataFacade {
  public abstract stages: Signal<Stage[]>;
}
